/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'ai-mate.agent-message.error': 'Last inn chat på nytt',
  'ai-mate.agent-message.error.aup-link-text': 'retningslinjer for akseptabel bruk',
  'ai-mate.agent-message.error.aup-one': 'Vi kan ikke svare på den ledeteksten.',
  'ai-mate.agent-message.error.aup-two':
    'Ledeteksten din er kanskje ikke i samsvar med våre {link}. Prøv en annen ledetekst.',
  'ai-mate.agent-message.error.copy-trace-id': 'Kopier sporings-ID',
  'ai-mate.agent-message.error.network-error': 'Det ser ut til å være et problem med nettverket.',
  'ai-mate.agent-message.error.resend': 'Send meldingen på nytt',
  'ai-mate.agent-message.error.trace-id': 'Sporings-ID: {traceId}',
  'ai-mate.agent-picker.dropdown-item.agents-dropdown-group-title': 'Agenter som kan hjelpe',
  'ai-mate.agent-picker.dropdown-item.chat-history': 'Chathistorikk',
  'ai-mate.agent-picker.dropdown-item.create': 'Opprett agent',
  'ai-mate.agent-picker.dropdown-item.debug-mode': 'Feilsøkingsmodus',
  'ai-mate.agent-picker.dropdown-item.get-help': 'Få hjelp',
  'ai-mate.agent-picker.dropdown-item.list': 'Bla gjennom agenter',
  'ai-mate.agent-picker.dropdown-item.submit-feedback': 'Send inn tilbakemelding',
  'ai-mate.agent-picker.dropdown-trigger-label': 'Velg agent',
  'ai-mate.agent-selector.default-agent-name': 'Chat',
  'ai-mate.browse-agents-view.close-button': 'Lukk agentvisning',
  'ai-mate.browse-agents-view.header-title': 'Bla gjennom agenter',
  'ai-mate.chat-history.conversationLimit':
    'Ser du etter en gammel chat? Vi tømmer chathistorikken etter 30 dager for å holde AI i gang.',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-1': 'Hvilke Confluence-sider har jeg bidratt til nylig?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-2': 'Finn alle Jira-saker som er tilordnet meg.',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-3': 'Hva er retningslinjene våre for reise?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-4':
    'Skriv et utkast til en Confluence-side for en markedsføringskampanje.',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-5': 'Hvordan kan jeg opprette en prosjekttidslinje?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-6': 'Skriv en oppfølgingsmelding til potensielle kunder.',
  'ai-mate.chat-history.empty-state.brand-name': 'Chat',
  'ai-mate.chat-history.empty-state.browse-agents-button-label': 'Bla gjennom agenter',
  'ai-mate.chat-history.empty-state.browse-agents-button-text': 'Bla gjennom agenter',
  'ai-mate.chat-history.empty-state.chat-with-agent-header': 'Chat med en Rovo-agent',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-1': 'Om dette området',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-2': 'Innsikter fra dette området',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-3': 'Områdeforslag',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-1': 'Finnes det ny aktivitet på sider jeg har skrevet?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-10':
    'Har `person` kommentert på noen sider jeg har publisert?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-11': 'Hva er de viktigste punktene fra «side»?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-2': 'Finnes det nye kommentarer som omtaler meg?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-3': 'Oppsummer de sist publiserte sidene i dette området.',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-4': 'Oppsummer bidragene mine til sider fra forrige uke.',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-5':
    'Kan du ta `siden` og skrive den på en mindre teknisk måte?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-6':
    'Opprett en mal for arbeidsplaner for prosjektadministrasjon.',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-7': 'Hvilke undersøkelser har vi om vanlige kundeproblemer?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-8':
    'Har noen i teamet mitt publisert noen nye sider denne uken?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-9': 'Har `person` publisert noen nye sider denne uken?',
  'ai-mate.chat-history.empty-state.confluence-home.suggestion1': 'Finnes det ny aktivitet på sider jeg har skrevet?',
  'ai-mate.chat-history.empty-state.confluence-home.suggestion2': 'Finnes det nye kommentarer som omtaler meg?',
  'ai-mate.chat-history.empty-state.confluence-home.suggestion3': 'Oppsummer de sist publiserte sidene i dette området',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-1': 'Kan du forbedre teksten på denne siden?',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-2': 'Skriv et kortfattet sammendrag for denne siden.',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-3': 'Gi meg noen koblinger til andre relevante sider.',
  'ai-mate.chat-history.empty-state.confluence-page-edit.suggestion1': 'Kan du forbedre teksten på denne siden?',
  'ai-mate.chat-history.empty-state.confluence-page-edit.suggestion2':
    'Skriv et kortfattet sammendrag for denne siden.',
  'ai-mate.chat-history.empty-state.confluence-page-edit.suggestion3':
    'Gi meg noen koblinger til andre relevante sider.',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-1': 'Om denne siden',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-2': 'Mer fra denne siden',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-3': 'Sideforslag',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-1': 'Oppsummer det jeg ser på.',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-2': 'Oppsummer kommentarene på denne siden.',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-3':
    'Forklar denne siden til meg som om jeg var nybegynner.',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-4':
    'Hvem skrev denne siden, og hvilket team er de fra?',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-5': 'Har noe på denne siden endret seg den siste uken?',
  'ai-mate.chat-history.empty-state.confluence-page-view.suggestion1': 'Oppsummer det jeg ser på.',
  'ai-mate.chat-history.empty-state.confluence-page-view.suggestion2':
    'Har noe på denne siden endret seg den siste uken?',
  'ai-mate.chat-history.empty-state.confluence-page-view.suggestion3': 'Oppsummer kommentarene på denne siden.',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-1': 'Om denne tavlen',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-2': 'Mer fra denne tavlen',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-3': 'Innsikt på denne tavlen',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-1': 'Oppsummer det jeg ser på.',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-2':
    'Fremhev eventuelle mønstre eller trender som er synlige her.',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-3':
    'Identifiser viktige handlingselementer eller beslutninger registrert på denne tavlen.',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.suggestion1': 'Oppsummer det jeg ser på.',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.suggestion2':
    'Fremhev eventuelle mønstre eller trender som er synlige her.',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.suggestion3':
    'Identifiser viktige handlingselementer eller beslutninger registrert på denne tavlen.',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.be-productive': 'Vær produktiv',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.draft-content': 'Lag utkast til innhold',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-information': 'Finn informasjon',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-people': 'Finn personer',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.get-answers': 'Få svar',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.measure-productivity': 'Mål produktivitet',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.rephrase-content': 'Omformuler innhold',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.stay-up-to-date': 'Vær oppdatert',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.summarize-content': 'Oppsummer innhold',
  'ai-mate.chat-history.empty-state.created-by-label': '<text>av</text> {creatorName}',
  'ai-mate.chat-history.empty-state.intro-text-headline': 'Hei, {userName}',
  'ai-mate.chat-history.empty-state.intro-text-link-text': 'Oppdag Rovo-chat og agenter',
  'ai-mate.chat-history.empty-state.intro-text-subheadline': 'Velg en samtalestarter eller spør om hva som helst.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1': 'Finn Jira-saker som har blitt oppdatert denne uken.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1-issue-term-refresh':
    'Finn Jira-arbeidsoppgaver som har blitt oppdatert denne uken.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2': 'Hvilke Jira-saker har høyest prioritering?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2-issue-term-refresh':
    'Hvilke Jira-arbeidsoppgaver har høyest prioritering?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3': 'Hvilke Jira-saker har kommentarer som omtaler meg?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3-issue-term-refresh':
    'Hvilke Jira-arbeidsoppgaver har kommentarer som omtaler meg?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4': 'Oppsummer kommentarene på `Jira-saken`.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4-issue-term-refresh':
    'Oppsummer kommentarene på `Jira-arbeidsoppgaven`.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-5': 'Opprett en beskrivelsesmal for brukerhistorier.',
  'ai-mate.chat-history.empty-state.jira-home.suggestion1': 'Finn Jira-saker som har blitt oppdatert denne uken.',
  'ai-mate.chat-history.empty-state.jira-home.suggestion1-issue-term-refresh':
    'Finn Jira-arbeidsoppgaver som har blitt oppdatert denne uken.',
  'ai-mate.chat-history.empty-state.jira-home.suggestion2': 'Hvilke saker har høyest prioritering?',
  'ai-mate.chat-history.empty-state.jira-home.suggestion2-issue-term-refresh':
    'Hvilke arbeidsoppgaver har høyest prioritering?',
  'ai-mate.chat-history.empty-state.jira-home.suggestion3': 'Hvilke saker har kommentarer som omtaler meg?',
  'ai-mate.chat-history.empty-state.jira-home.suggestion3-issue-term-refresh':
    'Hvilke arbeidsoppgaver har kommentarer som omtaler meg?',
  'ai-mate.chat-history.empty-state.jira-issue-list.suggestion1': 'Hvilke saker er ikke tilordnet?',
  'ai-mate.chat-history.empty-state.jira-issue-list.suggestion1-issue-term-refresh':
    'Hvilke arbeidsoppgaver er ikke tilordnet?',
  'ai-mate.chat-history.empty-state.jira-issue-list.suggestion2': 'Hvilke saker har vært åpne lengst?',
  'ai-mate.chat-history.empty-state.jira-issue-list.suggestion2-issue-term-refresh':
    'Hvilke arbeidsoppgaver har vært åpne lengst?',
  'ai-mate.chat-history.empty-state.jira-issue-list.suggestion3': 'Hvem har flest oppgaver?',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1': 'Om denne saken',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1-issue-term-refresh': 'Om denne arbeidsoppgaven',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2': 'Mer fra denne saken',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2-issue-term-refresh': 'Mer fra denne arbeidsoppgaven',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3': 'Innsikt fra denne saken',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3-issue-term-refresh': 'Innsikt om denne arbeidsoppgaven',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4': 'Saksforslag',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4-issue-term-refresh': 'Forslag til arbeidsoppgave',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1': 'Finnes det andre Jira-saker som ligner på denne?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1-issue-term-refresh':
    'Finnes det andre Jira-arbeidsoppgaver som ligner på denne?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-2': 'Hvordan kan jeg forbedre beskrivelsen?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3': 'Hvilke etiketter kan jeg legge til i denne saken?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3-issue-term-refresh':
    'Hvilke etiketter kan jeg legge til i denne arbeidsoppgaven?',
  'ai-mate.chat-history.empty-state.jira-issue-view.suggestion1': 'Finnes det andre Jira-saker som ligner på denne?',
  'ai-mate.chat-history.empty-state.jira-issue-view.suggestion1-issue-term-refresh':
    'Finnes det andre Jira-arbeidsoppgaver som ligner på denne?',
  'ai-mate.chat-history.empty-state.jira-issue-view.suggestion2': 'Hvordan kan jeg forbedre beskrivelsen?',
  'ai-mate.chat-history.empty-state.jira-issue-view.suggestion3': 'Hvilke etiketter kan jeg legge til i denne saken?',
  'ai-mate.chat-history.empty-state.jira-issue-view.suggestion3-issue-term-refresh':
    'Hvilke etiketter kan jeg legge til i denne arbeidsoppgaven?',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-1': 'Om dette prosjektet',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-2': 'Innsikt fra dette prosjektet',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-3': 'Mer fra dette prosjektet',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-4': 'Prosjektforslag',
  'ai-mate.chat-history.empty-state.jira-project-prompt-1': 'Hva har ikke blitt jobbet på på en stund?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10': 'Finn og grupper lignende Jira-saker.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10-issue-term-refresh':
    'Finn og grupper lignende Jira-arbeidsoppgaver.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11':
    'Er det noen Jira-saker som ikke er koblet til en overordnet sak?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11-issue-term-refresh':
    'Er det noen Jira-arbeidsoppgaver som ikke er koblet til en overordnet arbeidsoppgave?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12':
    'Ta beskrivelsen av `Jira-saken` og tilpass den etter beste praksis.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12-issue-term-refresh':
    'Ta beskrivelsen av `Jira-arbeidsoppgaven` og tilpass den etter beste praksis.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13': 'Oppsummer kommentarene på `Jira-saken`.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13-issue-term-refresh':
    'Oppsummer kommentarene på `Jira-arbeidsoppgaven`.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14': 'Opprett en beskrivelsesmal for brukerhistorier.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14-issue-term-refresh':
    'Opprett en beskrivelsesmal for brukerhistorier.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2': 'Er noen Jira-saker blokkert?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2-issue-term-refresh': 'Er noen Jira-arbeidsoppgaver blokkert?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3':
    'Oppgi Jira-saker som for øyeblikket har statusen «Pågår», og grupper dem etter tilordnet person.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3-issue-term-refresh':
    'Oppgi Jira-arbeidsoppgaver som for øyeblikket har statusen «Pågår», og grupper dem etter tilordnet person.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-4': 'Hvor mange saker er tilordnet `person`?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-4-issue-term-refresh':
    'Hvor mange arbeidsoppgaver er tilordnet til personen?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5':
    'Har `person` kommentert på noen Jira-saker i denne sprinten?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5-issue-term-refresh':
    'Har `person` kommentert på noen Jira-arbeidsoppgaver i denne sprinten?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6': 'Hvilke Jira-saker er ikke tilordnet?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6-issue-term-refresh':
    'Hvilke Jira-arbeidsoppgaver er ikke tilordnet?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7': 'Hvilke Jira-saker har vært åpne lengst?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7-issue-term-refresh':
    'Hvilke Jira-arbeidsoppgaver har vært åpne lengst?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-8': 'Hvem har flest oppgaver?',
  'ai-mate.chat-history.empty-state.message': 'Få svar, generer nye idéer og sett fart på det daglige arbeidet.',
  'ai-mate.chat-history.empty-state.suggestion1': 'Er noen av støtteforespørslene mine forsinket?',
  'ai-mate.chat-history.empty-state.suggestion2': 'Hva bør jeg jobbe på nå?',
  'ai-mate.chat-history.empty-state.suggestion3': 'Skriv en oppdatering om uken min',
  'ai-mate.chat-history.empty-state.unknown-llm-label-1': 'Forslag',
  'ai-mate.chat-history.store-assistant.message-actions.cancel-button': 'Avbryt',
  'ai-mate.chat-history.store-assistant.message-actions.confirm-button': 'Bekreft',
  'ai-mate.chat-history.store-assistant.message-actions.errored-button':
    'Det oppstod et problem med å fullføre denne handlingen',
  'ai-mate.chat-input.actions-button.label': 'Sett inn elementer',
  'ai-mate.chat-input.add-a-link-button.label': 'Legg til en kobling',
  'ai-mate.chat-input.deleted-agent-icon-label': 'Agenten er slettet',
  'ai-mate.chat-input.deleted-agent-start-new-chat': 'Start ny chat',
  'ai-mate.chat-input.deleted-agent-warning': 'Denne agenten er slettet.',
  'ai-mate.chat-input.drag-and-drop-message': 'Dra og slipp for å legge til kontekst og få bedre resultater',
  'ai-mate.chat-input.file-close-icon-label': 'Fjern fil',
  'ai-mate.chat-input.mention-someone-button.label': 'Omtal noen eller et team',
  'ai-mate.chat-input.placeholder': 'Skriv en ledetekst for å komme i gang',
  'ai-mate.chat-input.send-button.label': 'Send inn',
  'ai-mate.chat-input.stop-generating-button.label': 'Slutt å generere',
  'ai-mate.chat-input.store-user-messages.label': 'Ta opp denne meldingen for å hjelpe oss forbedre svarkvaliteten',
  'ai-mate.chat-main-header.back-button.label': 'Tilbake',
  'ai-mate.chat-main-header.copy-agent-link-button.label': 'Kopier kobling',
  'ai-mate.chat-main-header.default-agent-name': 'Chat',
  'ai-mate.chat-main-header.edit-agent-button.label': 'Rediger',
  'ai-mate.chat-main-header.link-copied-to-profile': 'Kopierte nettadresse',
  'ai-mate.chat-view.chat-item.chat-delete-label': 'Slett',
  'ai-mate.chat-view.chat-item.chat-rename-label': 'Gi nytt navn',
  'ai-mate.chat-view.chat-item.options-button-label': 'Chat-alternativer',
  'ai-mate.content-renderer.profile-card.view-profile-button': 'Vis profil',
  'ai-mate.content-renderer.view-code-button-label': 'Vis analyse',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'Avbryt',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    'Samtalen du prøver å slette, finnes ikke.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': 'Slett',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    'Vil du slette samtalen «{name}»?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    'Det oppstod en feil under slettingen av samtalen. Prøv på nytt.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'Er du sikker på at du vil slette denne samtalen? Denne handlingen kan ikke angres.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'Avbryt',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    'Kanalen du prøver å redigere, finnes ikke.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': 'Navn',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    'Det oppstod en feil under redigeringen av samtalen. Prøv på nytt.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': 'Rediger samtale',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    'Navnet er likt nåværende navn.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': 'Lagre',
  'ai-mate.conversation-list-view.back-button.label': 'Tilbake',
  'ai-mate.conversation-list-view.close-chat-button.label': 'Lukk chat',
  'ai-mate.conversation-list-view.header-title': 'Chathistorikk',
  'ai-mate.conversation-list-view.new-chat-button.label': 'Ny chat',
  'ai-mate.conversation-list-view.no-chat': 'Ingen resultater',
  'ai-mate.conversation-list-view.search-input.placeholder': 'Søk i chatter',
  'ai-mate.expander.hide-details': 'Skjul detaljer',
  'ai-mate.expander.show-details': 'Vis flere detaljer',
  'ai-mate.footer.beta': 'BETA',
  'ai-mate.footer.info': 'Kvaliteten på innholdet kan variere',
  'ai-mate.footer.info-truncated': 'Kvaliteten på innholdet kan variere',
  'ai-mate.footer.info-updated': 'Innholdet er basert på tillatelsene dine, og kvaliteten på det kan variere',
  'ai-mate.footer.rovo-branding-label': '{logo} Rovo',
  'ai-mate.footer.rovo-branding-label-updated': 'Rovo {logo}',
  'ai-mate.main-chat.close-chat-button-label': 'Lukk',
  'ai-mate.main-chat.maximize-chat-button-label': 'Fullskjerm',
  'ai-mate.main-chat.minimize-chat-button-label': 'Gjenopprett visningen',
  'ai-mate.main-chat.new-chat-button-label': 'Nytt',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Ny chat',
  'ai-mate.main-panel.failed-to-load-agents': 'Kan ikke hente agenter',
  'ai-mate.message-renderer.error': 'Gi oss beskjed hvis problemet vedvarer.',
  'ai-mate.message-renderer.error-title': 'Kan ikke laste inn innholdet',
  'ai-mate.pubsub-listener.forge-auth-faiure-message': 'Kan ikke bekrefte, prøv igjen om et øyeblikk.',
  'ai-mate.pubsub-listener.forge-auth-success-message': 'Bekreftet, send ledeteksten på nytt.',
  'ai-mate.sidebar.agents-icon.text': 'Agenter',
  'ai-mate.sidebar.agents-icon.tooltip': 'Bla gjennom Rovo-agenter',
  'ai-mate.sidebar.chat-icon.text': 'Chat',
  'ai-mate.sidebar.chat-icon.tooltip': 'Chat med Rovo',
  'ai-mate.sidebar.debug-mode-icon.tooltip': 'Feilsøking',
  'ai-mate.sidebar.get-help-icon.tooltip': 'Få hjelp',
  'ai-mate.sidebar.give-feedback-icon.tooltip': 'Gi tilbakemelding',
  'ai-mate.sidebar.history-icon.text': 'Historikk',
  'ai-mate.sidebar.history-icon.tooltip': 'Se chathistorikken din',
  'chat-history.rate-limit-warning':
    '{secondsRemaining, plural, one {Vent i {secondsRemaining,number} sekund} other {Vent i {secondsRemaining,number} sekunder}}',
  'chat-history.rate-limit-warning-description': 'Meldingene sendes for fort, vent litt.',
  'chatHistory.storeAssistant.badResponseLabel': 'Dårlig svar',
  'chatHistory.storeAssistant.copyResponseLabel': 'Kopier',
  'chatHistory.storeAssistant.goodResponseLabel': 'Godt svar',
  'rovo-chat.chat-input.editor-context-banner.editor-context-toggle-label': 'Bruk denne konteksten',
  'rovo-chat.data-sculptor-modal.cancel': 'Avbryt',
  'rovo-chat.data-sculptor-modal.title': 'Analyse',
  'rovo-chat.file-upload-button.label': 'Last opp fil',
  'rovo-chat.file-upload-button.max-files-label':
    '{maxFiles, plural, one {Grensen på {maxFiles,number} fil er nådd} other {Grensen på {maxFiles,number} filer er nådd}}',
  'rovo-chat.file-upload-dropzone.drag-drop-message': 'Dra og slipp for å legge til kontekst',
  'rovo-chat.message-file.icon-label': 'Fil',
  'rovo-chat.store-assistant.insert-replace.confluence-insert-button-label': 'Sett inn på siden',
  'rovo-chat.store-assistant.insert-replace.generic-insert-button-label': 'Sett inn',
  'rovo-chat.store-assistant.insert-replace.jira-insert-button-label': 'Sett inn i sak',
  'rovo-chat.store-assistant.insert-replace.replace-button-label': 'Erstatt valgt tekst',
  'rovo-chat.store-assistant.insert-replace.tooltip-message':
    'Denne funksjonen støttes ikke ennå i gjeldende sammenheng. Prøv å merke, skrive eller redigere tekst på siden.',
};
